var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import IconWrapper from "./IconWrapper";
export default React.forwardRef((_a, ref) => {
    var { color = "primary" } = _a, otherProps = __rest(_a, ["color"]);
    return (React.createElement(IconWrapper, Object.assign({ ref: ref, width: 24, height: 24, color: color }, otherProps),
        React.createElement("path", { d: "M8.69127 21L14.5114 10.418L21 13.9573V19C21 20.1046 20.1046 21 19 21H8.69127Z" }),
        React.createElement("path", { d: "M6.40873 21H5C3.89543 21 3 20.1046 3 19V9.23L10.6017 13.3764L6.40873 21Z" }),
        React.createElement("path", { d: "M3 6.95182L11.5656 11.6239L16.3087 3H5C3.89543 3 3 3.89543 3 5V6.95182Z" }),
        React.createElement("path", { d: "M18.5913 3L15.4752 8.66557L21 11.6791V5C21 3.89543 20.1046 3 19 3H18.5913Z" })));
});
//# sourceMappingURL=Area.js.map